import loadSwitch from './switchLoader'
const MandatoryLoader = () => {
  return {
    mandatoryResponse: (key) => {
      const switches = {...loadSwitch};
        const tempSwitches = {}
        Object.keys(switches).map((indiSwitch) => tempSwitches[switches[indiSwitch]]= indiSwitch)

        return tempSwitches[key];
    },
  };
};

export default MandatoryLoader;
